<empty-state
  emojiPathUrl="assets/images/emojis/1f608.svg"
  [title]="titleKey ? (titleKey | translate) : undefined"
  [msg]="msgKey | translate"
>
  <ng-content select="[suffix]" suffix></ng-content>
</empty-state>
